import { render, staticRenderFns } from "./ProductImageSelect.vue?vue&type=template&id=b2bb6f60"
import script from "./ProductImageSelect.vue?vue&type=script&lang=js"
export * from "./ProductImageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2bb6f60')) {
      api.createRecord('b2bb6f60', component.options)
    } else {
      api.reload('b2bb6f60', component.options)
    }
    module.hot.accept("./ProductImageSelect.vue?vue&type=template&id=b2bb6f60", function () {
      api.rerender('b2bb6f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/components/ProductImageSelect.vue"
export default component.exports